import { Answer } from "./Answer";
import { Question } from "./Question";
import { QuestionIllustration } from "./QuestionIllustration";
import { QuizCountry } from "./QuizCountry";

export class UKQuiz 
{
    private _questions: Array<Question> = [];

    constructor()
    {
        this._questions = [
            new Question("What is the Tower of London?",
                [
                    new Answer("A famous clock tower", false),
                    new Answer("A royal palace", false),
                    new Answer("A historic fortress", true),
                    new Answer("A shopping mall", false),
                ],
                QuestionIllustration.TowerOfLondon,
                QuizCountry.UK
            ),
            new Question("Where is the Tower of London located?",
                [
                    new Answer("Paris, France", false),
                    new Answer("Rome, Italy", false),
                    new Answer("London, England", true),
                    new Answer("New York, USA", false),
                ],
                QuestionIllustration.TowerOfLondon,
                QuizCountry.UK
            ),
            new Question("What is the purpose of the Tower of London?",
                [
                    new Answer("To house the crown jewels", false),
                    new Answer("To serve as a prison", false),
                    new Answer("To protect the city", false),
                    new Answer("All the above", true),
                ],
                QuestionIllustration.TowerOfLondon,
                QuizCountry.UK
            ),
            new Question("Where is Windsor Castle located?",
                [
                    new Answer("Windsor, England", true),
                    new Answer("Paris, France", false),
                    new Answer("Rome, Italy", false),
                    new Answer("Barcelona, Spain", false),
                ],
                QuestionIllustration.WindsorCastle,
                QuizCountry.UK
            ),

            new Question("What is the main function of Windsor Castle?",
                [
                    new Answer("A royal residence", true),
                    new Answer("A shopping centre", false),
                    new Answer("A museum", false),
                    new Answer("A school ", false),
                ],
                QuestionIllustration.WindsorCastle,
                QuizCountry.UK
            ),

            // River Thames (Same as tower of london)
            new Question("Which city is the River Thames associated with?",
                [
                    new Answer("London", true),
                    new Answer("Paris", false),
                    new Answer("New York", false),
                    new Answer("Sydney ", false),
                ],
                QuestionIllustration.TowerOfLondon,
                QuizCountry.UK
            ),
            new Question("Which famous bridge crosses the River Thames in London?",
                [
                    new Answer("Golden Gate Bridge", false),
                    new Answer("Tower Bridge", true),
                    new Answer("Sydney Harbour Bridge", false),
                    new Answer("Brooklyn Bridge ", false),
                ],
                QuestionIllustration.TowerOfLondon,
                QuizCountry.UK
            ),

            // Big Ben
            new Question("What is Big Ben?",
                [
                    new Answer("The bell inside the clock", true),
                    new Answer("A famous bridge", false),
                    new Answer("A tall building", false),
                    new Answer("A type of bird ", false),
                ],
                QuestionIllustration.BigBen,
                QuizCountry.UK
            ),
            new Question("Where is Big Ben located?",
                [
                    new Answer("Paris, France", false),
                    new Answer("Rome, Italy", false),
                    new Answer("London, England", true),
                    new Answer("New York City, USA", false),
                ],
                QuestionIllustration.BigBen,
                QuizCountry.UK
            ),
            new Question("What is the purpose of Big Ben?",
                [
                    new Answer("To keep time", true),
                    new Answer("To provide a scenic view", false),
                    new Answer("To hold concerts", false),
                    new Answer("To scare away pigeons", false),
                ],
                QuestionIllustration.BigBen,
                QuizCountry.UK
            ),

            // Royalty (same image as Windsor)
            new Question("Where does the British monarch live?",
                [
                    new Answer("Buckingham Palace", false),
                    new Answer("Windsor Castle", false),
                    new Answer("Kensington Palace", false),
                    new Answer("All of the above", true),
                ],
                QuestionIllustration.WindsorCastle,
                QuizCountry.UK
            ),
            new Question("What is the last name of the Royal family?",
                [
                    new Answer("Windsor", true),
                    new Answer("Mountbatten", false),
                    new Answer("Tudor", false),
                    new Answer("Stuart", false),
                ],
                QuestionIllustration.WindsorCastle,
                QuizCountry.UK
            ),
            new Question("Who is the current King of the United Kingdom and 14 other Commonwealth realms?",
                [
                    new Answer("King Henry VIII", false),
                    new Answer("King Edward IV", false),
                    new Answer("King Charles III", true),
                    new Answer("King William the Conqueror", false),
                ],
                QuestionIllustration.WindsorCastle,
                QuizCountry.UK
            ),
            new Question("Which queen ruled England for 63 years, making her the longest-reigning monarch in British history?",
                [
                    new Answer("Queen Elizabeth II", true),
                    new Answer("Queen Victoria", false),
                    new Answer("Queen Mary I", false),
                    new Answer("Queen Anne", false),
                ],
                QuestionIllustration.WindsorCastle,
                QuizCountry.UK
            ),

            // London Busses
            new Question("What colour is the iconic double-decker London Bus?",
                [
                    new Answer("Red", true),
                    new Answer("Blue", false),
                    new Answer("Green", false),
                    new Answer("Yellow", false),
                ],
                QuestionIllustration.LondonBus,
                QuizCountry.UK
            ),
            new Question("What is the name of the person who drives a London Bus?",
                [
                    new Answer("Pilot", false),
                    new Answer("Conductor", false),
                    new Answer("Driver", true),
                    new Answer("Captain", false),
                ],
                QuestionIllustration.LondonBus,
                QuizCountry.UK
            ),
            new Question("Which famous bridge in London do the London Buses often cross?",
                [
                    new Answer("Tower Bridge", true),
                    new Answer("Golden Gate Bridge", false),
                    new Answer("Brooklyn Bridge", false),
                    new Answer("Sydney Harbour Bridge", false),
                ],
                QuestionIllustration.LondonBus,
                QuizCountry.UK
            ),

            // Travel
            new Question("What is the Elizabeth Line?",
                [
                    new Answer("A famous dance move", false),
                    new Answer("A river in London", false),
                    new Answer("An underground train line", true),
                    new Answer("A popular video game", false),
                ],
                QuestionIllustration.LondonBus,
                QuizCountry.UK
            ),
            new Question("Which type of train runs underground in London?",
                [
                    new Answer("Tube", true),
                    new Answer("Monorail", false),
                    new Answer("Tram", false),
                    new Answer("Cable car", false),
                ],
                QuestionIllustration.LondonBus,
                QuizCountry.UK
            ),


            // Stonehenge
            new Question("Where is Stonehenge located",
                [
                    new Answer("United States", false),
                    new Answer("France", false),
                    new Answer("Egypt", false),
                    new Answer("England", true),
                ],
                QuestionIllustration.Stonehenge,
                QuizCountry.UK
            ),
            new Question("How old is Stonehenge?",
                [
                    new Answer("100 years", false),
                    new Answer("500 years", false),
                    new Answer("1,000 years", false),
                    new Answer("5,000 years", true),
                ],
                QuestionIllustration.Stonehenge,
                QuizCountry.UK
            ),
            new Question("What is the purpose of Stonehenge?",
                [
                    new Answer("A burial site", true),
                    new Answer("A castle", false),
                    new Answer("A shopping centre", false),
                    new Answer("A sports arena", false),
                ],
                QuestionIllustration.Stonehenge,
                QuizCountry.UK
            ),
            new Question("What are the White Cliffs of Dover made of?",
                [
                    new Answer("Sand", false),
                    new Answer("Limestone", true),
                    new Answer("Granite", false),
                    new Answer("Volcanic rock", false),
                ],
                QuestionIllustration.WhiteCliffsOfDover,
                QuizCountry.UK
            ),
            new Question("Which ocean is the UK coastline a part of?",
                [
                    new Answer("Atlantic Ocean", true),
                    new Answer("Indian Ocean", false),
                    new Answer("Pacific Ocean", false),
                    new Answer("Arctic Ocean", false),
                ],
                QuestionIllustration.WhiteCliffsOfDover,
                QuizCountry.UK
            ),
            new Question("What is the term used for the land where the sea meets the coastline?",
                [
                    new Answer("Beach", true),
                    new Answer("Dunes", false),
                    new Answer("Cliff", false),
                    new Answer("Estuary", false),
                ],
                QuestionIllustration.WhiteCliffsOfDover,
                QuizCountry.UK
            ),

            // Royal guardsmen
            new Question("What are Royal Guardsmen?",
                [
                    new Answer("Soldiers who protect the King", true),
                    new Answer("Members of a band", false),
                    new Answer("Teachers at a royal school", false),
                    new Answer("Royal chefs", false),
                ],
                QuestionIllustration.RoyalGuards,
                QuizCountry.UK
            ),
            new Question("Where can you usually find Royal Guardsmen?",
                [
                    new Answer("Buckingham Palace", true),
                    new Answer("Tower Bridge", false),
                    new Answer("Big Ben", false),
                    new Answer("London Eye", false),
                ],
                QuestionIllustration.RoyalGuards,
                QuizCountry.UK
            ),
            new Question("Which iconic hat is worn by the royal guardsmen?",
                [
                    new Answer("Beret", false),
                    new Answer("Cap", false),
                    new Answer("Helmet", false),
                    new Answer("Bearskin", true),
                ],
                QuestionIllustration.RoyalGuards,
                QuizCountry.UK
            ),

            // Blackpool

            new Question("What is Blackpool famous for?",
                [
                    new Answer("Theme parks", false),
                    new Answer("Beaches", false),
                    new Answer("Illuminations", false),
                    new Answer("All of the above", true),
                ],
                QuestionIllustration.Blackpool,
                QuizCountry.UK
            ),
            new Question("What is the name of the iconic tower in Blackpool?",
                [
                    new Answer("Eiffel Tower", false),
                    new Answer("Blackpool Tower", true),
                    new Answer("Big Ben", false),
                    new Answer("Leaning Tower of Pisa", false),
                ],
                QuestionIllustration.Blackpool,
                QuizCountry.UK
            ),
            new Question("What is the famous annual light festival called in Blackpool?",
                [
                    new Answer("Fireworks Spectacular", false),
                    new Answer("Carnival of Lights", true),
                    new Answer("Glow Fest", false),
                    new Answer("Night Magic", false),
                ],
                QuestionIllustration.Blackpool,
                QuizCountry.UK
            ),
            new Question("What is the traditional British meal often enjoyed at the seaside?",
                [
                    new Answer("Pizza", false),
                    new Answer("Fish and chips", true),
                    new Answer("Ice cream", false),
                    new Answer("Hamburger", false),
                ],
                QuestionIllustration.Blackpool,
                QuizCountry.UK
            ),

            // Hadrians wall
            new Question("Where is Hadrian's Wall located?",
                [
                    new Answer("France", false),
                    new Answer("Spain", false),
                    new Answer("Italy", false),
                    new Answer("England", true),
                ],
                QuestionIllustration.HadriansWall,
                QuizCountry.UK
            ),
            new Question("What is Hadrian's Wall?",
                [
                    new Answer("A famous bridge in London", false),
                    new Answer("A long wall built by the ancient Romans", true),
                    new Answer("A castle in Scotland", false),
                    new Answer("A mountain range in England", false),
                ],
                QuestionIllustration.HadriansWall,
                QuizCountry.UK
            ),
            new Question("What was the purpose of Hadrian's Wall?",
                [
                    new Answer("To protect England from invaders", true),
                    new Answer("To hold royal ceremonies", false),
                    new Answer("To serve as a trade route", false),
                    new Answer("To provide shelter for travelers", false),
                ],
                QuestionIllustration.HadriansWall,
                QuizCountry.UK
            ),
            new Question("What animal is commonly found in the British countryside?",
                [
                    new Answer("Kangaroos", false),
                    new Answer("Penguins", false),
                    new Answer("Cows and sheep", true),
                    new Answer("Monkeys", false),
                ],
                QuestionIllustration.HadriansWall,
                QuizCountry.UK
            ),
            new Question("What activity can you enjoy in the British countryside?",
                [
                    new Answer("Hiking and camping", true),
                    new Answer("Surfing and scuba diving", false),
                    new Answer("Skiing and snowboarding", false),
                    new Answer("Shopping and sighseeing", false),
                ],
                QuestionIllustration.HadriansWall,
                QuizCountry.UK
            ),
            new Question("What is the British countryside known for?",
                [
                    new Answer("Rolling hills and green fields", true),
                    new Answer("Skyscrapers and busy streets", false),
                    new Answer("Beaches and palm trees", false),
                    new Answer("Deserts and sand dunes", false),
                ],
                QuestionIllustration.HadriansWall,
                QuizCountry.UK
            ),

            // Flag
            new Question("Which of these countries is part of the United Kingdom?",
                [
                    new Answer("France", false),
                    new Answer("Germany", false),
                    new Answer("Scotland", true),
                    new Answer("Italy", false),
                ],
                QuestionIllustration.Flag,
                QuizCountry.UK
            ),
            new Question("What is the capital city of the United Kingdom?",
                [
                    new Answer("Paris", false),
                    new Answer("Berlin", false),
                    new Answer("London", true),
                    new Answer("Madrid", false),
                ],
                QuestionIllustration.Flag,
                QuizCountry.UK
            ),
            new Question("What is the popular sport played in the United Kingdom?",
                [
                    new Answer("Football", true),
                    new Answer("Baseball", false),
                    new Answer("Cricket", false),
                    new Answer("Swimming", false),
                ],
                QuestionIllustration.Flag,
                QuizCountry.UK
            ),
            new Question("Which famous royal family lives in the United Kingdom?",
                [
                    new Answer("The Queen of Hearts", false),
                    new Answer("The Lion King", false),
                    new Answer("The British Royal Family", true),
                    new Answer("The Avengers", false),
                ],
                QuestionIllustration.Flag,
                QuizCountry.UK
            ),
        ];
    }

    public get questions(): Array<Question> { return this._questions; }
}